import { useState, useEffect } from "react"
import { Row, Col, Dropdown, NavDropdown, Button, Table, Form, FormControl, Badge, CloseButton, InputGroup, Spinner } from "react-bootstrap"
import AzioniTabellaSondaggio from "./AzioniTabellaSondaggio";
import { GoSearch } from "react-icons/go"
import { IoMdAdd } from "react-icons/io"
import { getSondaggioColor } from '../../Utilities/getBorderColor'
import { getStatusSondaggio } from "../../Utilities/getStatus"
import { getStatusOrderSondaggio } from "../../Utilities/getStatusOrder";
import dayjs from "dayjs";
import { statiSondaggio } from "../../Utilities/statiElementEnum";
import { convertSondaggiToCsv } from "../../Utilities/covertToCSV";
import { PiFileCsv } from "react-icons/pi";

/*
PROPS passate
comune={comune}
sondaggi={sondaggi}
setSonId={setSonId}
setMostraTabella={props.setMostraTabella}
setGestisci={setGestisci}
statoFilter={statoFilter}
setStatoFilter={setStatoFilter}
setDirty={setDirty}
dirty={dirty}
categoriaFilter={categoriaFilter}
setCategoriaFilter={setCategoriaFilter}
*/

export default function TabellaSondaggi(props) {

    let [sondaggi, setSondaggi] = useState([])

    const [titolo, setTitolo] = useState("")

    const getSondaggi = () => {
        let ret = sondaggi.map(son => {
            
            return son
        })

        if (props.statoFilter?.length > 0) {
            ret = ret.filter((son) => son.sonStato === props.statoFilter)
        }

        if (props.categoriaFilter?.length > 0) {
            ret = ret.filter((son) => son.sonCategorie.categorie.includes(props.categoriaFilter))
        }

        if (titolo) {
            ret = ret.filter((son) => son.sonTitolo.toLowerCase().includes(titolo.toLowerCase()))
        }

        return ret
    }

    let filterByStato = (stato) => {
        props.setStatoFilter(stato)
    }

    let resetStato = () => {
        props.setStatoFilter("")
    }

    let filterByCategoria = (categoria) => {
        props.setCategoriaFilter(categoria)
    }

    let resetCategoria = () => {
        props.setCategoriaFilter("")
    }

    const addSondaggio = () => {
        props.setMostraTabella(false)
        props.setGestisci("aggiungi-sondaggio")
    }

    let categorie = [...new Set(
        [
            ...getSondaggi().flatMap(s => s.sonCategorie?.categorie || []), // Appiattisce le categorie dei sondaggi
            ...(props.comune?.impostazioniComune?.imcCategorieSondaggi?.categorie_sondaggi || []) //Categorie dalle impostazioni del comune
        ]
    )];

    useEffect(() => {
        let sondaggi = []
        props.sondaggi.forEach(son => {
            let sondaggio = {
                sonId: son.sonId,
                sonTitolo: son.sonTitolo,
                sonDataInizio: son.sonDataInizio,
                sonDataChiusura: son.sonDataChiusura,
                sonDescrizione: son.sonDescrizione,
                sonStato: getStatusSondaggio(son), // probabilmente adesso che è fatto da backend si può togliere
                sonCategorie: son.sonCategorie
            }
            sondaggi.push(sondaggio)
        })
        setSondaggi(sondaggi)
    }, [props])

    // Funzione per scaricare il CSV
    const handleDownloadReports = () => {
        const csvContent = convertSondaggiToCsv(props.sondaggi, props.comune); // Converti i dati in CSV
        const url = window.URL.createObjectURL(new Blob([csvContent])); // Crea l'URL
        const link = document.createElement('a');
        const fileName = `Sondaggi_${dayjs(new Date()).format("DDMMYYHHmm")}.csv`;
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    return (
        <>
            {/* Prima riga: Filtra e Cerca */}
            <Row className="d-flex justify-content-between align-items-center flex-wrap my-4 gap-2">
                {/* Dropdown Filtra */}
                <Col xs="auto">
                    <Dropdown autoClose="true">
                        <Dropdown.Toggle id="dropdown-autoclose-outside">
                            <span className="px-4">Filtra</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <NavDropdown title="Stato" drop="end" onSelect={filterByStato}>
                                {Object.values(statiSondaggio).map((stato, index) => (
                                    <NavDropdown.Item key={index} eventKey={stato}>
                                        {stato}
                                    </NavDropdown.Item>
                                ))}
                            </NavDropdown>
                            <NavDropdown
                    title="Categoria"
                    drop="end"
                    id="nav-dropdown-categoria" // Aggiunto ID
                    // --- AGGIUNTA CONDIZIONE DISABLED ---
                    disabled={!categorie || categorie.length === 0}
                >
                    {/* Mostra le categorie solo se ce ne sono */}
                    {categorie && categorie.length > 0 ? (
                        categorie.map((categoria, index) => (
                            <NavDropdown.Item key={`cat-${index}`} eventKey={categoria} onClick={() => filterByCategoria(categoria)}>
                                {categoria}
                            </NavDropdown.Item>
                        ))
                    ) : (
                        // Mostra un item disabilitato se non ci sono categorie
                        <NavDropdown.Item disabled style={{ fontStyle: 'italic', color: 'grey' }}>
                            Nessuna categoria
                        </NavDropdown.Item>
                    )}
                </NavDropdown>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>

                {/* Barra di ricerca */}
                <Col xs={12} md="auto" className="d-flex flex-grow-1">
                    <InputGroup className="w-100">
                        <InputGroup.Text id="basic-addon1">
                            <GoSearch />
                        </InputGroup.Text>
                        <FormControl
                            placeholder="Cerca titolo..."
                            onChange={(ev) => { setTitolo(ev.target.value) }}
                        />
                    </InputGroup>
                </Col>

                {/* Bottone "Nuovo" */}
                <Col xs="auto">
                    <Button onClick={addSondaggio} className="d-flex align-items-center">
                        Nuovo <IoMdAdd style={{ fontSize: "1.3em", marginLeft: "5px" }} />
                    </Button>
                </Col>

                {/* Bottone "Esporta CSV" */}
                <Col xs="auto">
                    <Button onClick={handleDownloadReports} variant="primary">
                        <PiFileCsv className="me-1" />
                        <span className="d-none d-md-inline">Esporta tabella in formato CSV</span>
                        <span className="d-inline d-md-none">Esporta CSV</span>
                    </Button>
                </Col>
            </Row>

            {/* Seconda riga: Filtri selezionati (solo se presenti) */}
            {(props.statoFilter.length > 0 || props.categoriaFilter.length > 0) && (
                <Row className="mt-2">
                    <Col xs={12} className="d-flex flex-wrap gap-2 overflow-auto">
                        {props.statoFilter.length > 0 && (
                            <div className="d-flex align-items-center bg-light p-1 px-2 rounded">
                                Stato: <strong className="ms-2">{props.statoFilter}</strong>
                                <Badge bg="outline-danger" className="ms-2">
                                    <CloseButton onClick={resetStato} />
                                </Badge>
                            </div>
                        )}
                        {props.categoriaFilter.length > 0 && (
                            <div className="d-flex align-items-center bg-light p-1 px-2 rounded">
                                Categoria: <strong className="ms-2">{props.categoriaFilter}</strong>
                                <Badge bg="outline-danger" className="ms-2">
                                    <CloseButton onClick={resetCategoria} />
                                </Badge>
                            </div>
                        )}
                    </Col>
                </Row>
            )}

            {/* Tabella */}
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>Titolo</th>
                        <th >Categoria</th>
                        <th className="text-center">Stato</th>
                        <th className="text-center">Data Inizio</th>
                        <th className="text-center">Data Chiusura</th>
                        <th className="text-center">Azioni</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.dirty ? (
                            <tr>
                                <td colSpan={6} style={{ textAlign: "center" }}>
                                    <Spinner animation="border" role="status">
                                        <span className="visually-hidden">Caricamento...</span>
                                    </Spinner>
                                </td>
                            </tr>
                        ) :
                            getSondaggi().length > 0 ? (
                                getSondaggi()
                                    .sort((a, b) => { return getStatusOrderSondaggio(a.sonStato) - getStatusOrderSondaggio(b.sonStato) })
                                    .map(sondaggio => (
                                        <tr key={sondaggio.sonId}>
                                            <td>{sondaggio.sonTitolo}</td>
                                            <td>{sondaggio.sonCategorie?.categorie?.join(", ")}</td>
                                            <td className="text-center">
                                                <Badge pill bg={getSondaggioColor(sondaggio)} className="pillText" style={{ minWidth: "90%" }}>
                                                    {sondaggio.sonStato}
                                                </Badge>
                                            </td>
                                            <td className="text-center">
                                                {sondaggio.sonDataInizio ? (
                                                    <>
                                                        {dayjs(sondaggio.sonDataInizio).format("DD/MM/YYYY")}<br />
                                                        <span style={{ fontSize: "0.85em", color: "#666" }}>
                                                            {dayjs(sondaggio.sonDataInizio).format("HH:mm")}
                                                        </span>
                                                    </>
                                                ) : "--"}
                                            </td>
                                            <td className="text-center">
                                                {sondaggio.sonDataChiusura ? (
                                                    <>
                                                        {dayjs(sondaggio.sonDataChiusura).format("DD/MM/YYYY")}<br />
                                                        <span style={{ fontSize: "0.85em", color: "#666" }}>
                                                            {dayjs(sondaggio.sonDataChiusura).format("HH:mm")}
                                                        </span>
                                                    </>
                                                ) : "--"}
                                            </td>
                                            <td>
                                                <AzioniTabellaSondaggio
                                                    sonId={sondaggio.sonId}
                                                    setSonId={props.setSonId}
                                                    stato={sondaggio.sonStato}
                                                    setMostraTabella={props.setMostraTabella}
                                                    setGestisci={props.setGestisci}
                                                />
                                            </td>
                                        </tr>
                                    ))
                            ) : (
                                <tr >
                                    <td colSpan={6}>
                                        Nessun sondaggio trovato
                                    </td>
                                </tr>
                            )
                    }
                </tbody>
            </Table>
        </>
    );


}